























import { Component, Mixins } from 'vue-property-decorator'

import AppTitleBar from '@/components/AppTitleBar.vue'
import OrderDelivery from '@/components/OrderDelivery.vue'
import OrderPayment from '@/components/OrderPayment.vue'

import { REQUEST_ORDER_CANCELLATION, ORDERFORM_QUERY } from '@/gql/order'
import { OrderMixin } from '@/mixins'
import { OrderForm } from '@/interfaces'

@Component({
  components: {
    AppTitleBar,
    OrderDelivery,
    OrderPayment
  },
  apollo: {
    orderForm: {
      query: ORDERFORM_QUERY,
      variables () {
        return {
          orderId: this.$route.params.id
        }
      }
    }
  }
})
export default class extends Mixins(OrderMixin) {
  orderForm!: OrderForm

  async requestCancel () {
    const result = confirm('주문을 취소하시겠습니까?')
    if (!result) {
      return
    }

    const { data } = await this.$apollo.mutate({
      mutation: REQUEST_ORDER_CANCELLATION,
      variables: {
        input: {
          orderId: this.orderForm.id,
          orderItemIds: [],
          orderCancelType: 'REFUND'
        }
      }
    })

    await this.showToast(data.requestOrderCancellation.message)
    if (data.requestOrderCancellation.success) {
      this.$router.back()
    }
  }
}
